<template>
  <header
    class="app-header"
    :class="{ isClosedMenu: isClosedMenu, isMobile: isMobile }"
  >
    <v-overlay
      style="z-index: 1"
      :value="!isClosedMenu"
      v-if="isMobile"
      @click.native="closeMenu"
    ></v-overlay>
    <LibHeaderAccessibilityPopup />
    <div class="bar-top content-padd-x">
      <div class="bar-content">
        <div class="bar-left">
          <div class="logo-cont" v-if="isMobile">
            <router-link to="/">
              <img class="logo" alt="Logo EDB" src="/img/logo-ckob.svg" />
            </router-link>
          </div>
          <LibBtnSimple
            v-if="!isMobile"
            text="Ustawienia dostępności"
            icon="mdi-human"
            color="primary"
            underline
            @click.native="openA11y"
            style="margin-left: -17px;"
          />
        </div>
        <div class="bar-right">
          <nav class="nav">
            <div class="account-btns" v-if="!isMobile">
              <router-link
                v-if="roleName"
                :to="{ name: 'AccountStart' }"
                class="role"
                title="Zmień rolę"
              >
                Rola: <span>{{ roleName }}</span>
              </router-link>
              <LibBadge
                title="Powiadomienia"
                color="primary"
                :to="{ name: 'AccountNotification' }"
                :text="messages"
              />
              <LibHeaderAccount />
            </div>
            <v-app-bar-nav-icon
              @click.stop="openCloseMenu"
              color="primaryBlue"
              v-if="isMobile"
              class="btn-drawer"
            ></v-app-bar-nav-icon>
          </nav>
        </div>
      </div>
    </div>
    <div class="banner-test content-padd" v-if="showBannerIsTest">
      <v-icon class="mr-1" color="#333399" size="20">
        mdi-alert-outline
      </v-icon>
      <div class="bold mr-1">
        System w wersji testowej
      </div>
      <div v-if="!isMobile">
        (nie wprowadzaj prawdziwych danych)
      </div>
    </div>
  </header>
</template>

<script>
import LibBtnSimple from "../common/LibBtnSimple.vue";
import LibHeaderAccessibilityPopup from "./LibHeaderAccessibilityPopup.vue";
import LibBadge from "../common/LibBadge.vue";
import LibHeaderAccount from "../common/LibHeaderAccount.vue";
import { mapGetters } from "vuex";
import { USER_MAIN_ROLE_I } from "@/util/dictionary-code-util.js";
export default {
  name: "LibAppHeader",
  components: {
    LibBtnSimple,
    LibHeaderAccessibilityPopup,
    LibHeaderAccount,
    LibBadge
  },

  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      messages: "auth/getMessagesCount",
      user: "auth/getUser"
    }),
    isClosedMenu() {
      return this.$store.state.layout.isClosedMenu;
    },
    isOpenA11y() {
      return this.$store.state.layout.isOpenA11y;
    },
    userRole() {
      return this.$store.state.auth.ckobRole;
    },
    roleName() {
      return this.$store.getters["dict/getEntry"]({
        dictionaryCode: USER_MAIN_ROLE_I,
        dictionaryEntryCode: this.userRole
      })?.value;
    },
    showBannerIsTest() {
      return process.env.VUE_APP_BANNER_IS_TEST === "true";
    }
  },
  methods: {
    openA11y() {
      this.$store.commit("layout/setStateA11y", true);
    },
    openCloseMenu() {
      this.$store.commit("layout/setStateMenu", !this.isClosedMenu);
    },
    closeMenu() {
      this.$store.commit("layout/setStateMenu", true);
    },
    login() {
      const props = this.$router.resolve({ name: "Account" });
      let path = window.location.origin.split(/[?#]/)[0];
      if (path.endsWith("/")) path = path.slice(0, -1);
      this.$store.dispatch("auth/login", { redirectUri: path + props.href });
    }
  }
};
</script>
<style lang="scss" scoped>
.app-header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 3;
  border-bottom: 1px solid hsl(240, 50%, 90%);
  background: var(--bg-grey);
  padding-left: var(--nav-width);
  transition: 0.3s padding;
  // box-shadow: 0px 0px 20px 0px rgba(78, 78, 78, 0.13);
  &.isClosedMenu {
    padding-left: 20px;
  }
  &.isMobile {
    padding-left: 0px;
  }
}

.account-btns {
  display: flex;
  align-items: center;
  gap: 24px;
}

.bar-top {
  position: relative;

  // color: #fff;
  height: 62px;
  .bar-left,
  .bar-right {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
  .bar-left {
    position: relative;
    // left: -16px;
  }
  .bar-right {
    position: relative;
  }

  .logo-cont {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo {
    width: 80px;
    display: block;
  }
  .bar-content {
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.role {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  span {
    font-weight: 500;
  }
}

.isMobile {
  background: #fff;
  &.app-header {
    box-shadow: 0px 0px 27px 3px rgba(51, 51, 153, 0.15);
  }
  .bar-top {
    height: 64px;
  }
  .btn-drawer {
    right: -8px;
  }
}

.banner-test {
  background-color: var(--c-yellow);
  color: var(--c-primary);
  text-align: center;
  padding: 5px 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

@media (width <= 1080px) {
  .role {
    display: none;
  }
}
</style>
